var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bk-item-box"},[_c('img',{staticClass:"bk-item-cover",attrs:{"src":_vm.cover
        ? _vm.$global.imgUrl + _vm.cover
        : require('@/assets/img/mobile-img/image_error_ic.webp'),"alt":""}}),_c('p',{staticClass:"bk-item-name",domProps:{"innerHTML":_vm._s(_vm.name)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }